import { generateOnboardingLink, updateOnboardingProgressWithApiKey } from "../../../shared/api/controllers/onboarding";
import OnboardingProgressModel from "../../../shared/models/onboarding/api/OnboardingProgressModel";
import IResult from "../../../shared/models/result/IResult";
import InvalidResult from "../../../shared/models/result/InvalidResult";
import { decodeOnboardingToken } from "./decodeOnboardingToken";

export interface SaveOnboardingProgressForApplicationResult {
    result: IResult<OnboardingProgressModel>;
    apiKey?: string;
}

export const saveOnboardingProgressForApplication = async (
    applicationId: string,
    progress: OnboardingProgressModel,
    existingApiKey?: string
): Promise<SaveOnboardingProgressForApplicationResult> => {
    let apiKey = existingApiKey;

    // The progress PUT endpoint selects the application from the API-key claim;
    // applicationId in the request body is not used to choose the saved record.
    if (!apiKey) {
        const linkResult = await generateOnboardingLink(applicationId);
        if (linkResult.resultType !== "Ok" || !linkResult.data) {
            return {
                result: new InvalidResult<OnboardingProgressModel>(
                    linkResult.errors?.[0] || "Failed to authorize the onboarding progress update."
                )
            };
        }

        try {
            const decodedToken = decodeOnboardingToken(linkResult.data);
            if (decodedToken.applicationId !== applicationId) {
                return {
                    result: new InvalidResult<OnboardingProgressModel>(
                        "The onboarding progress update was authorized for a different application."
                    )
                };
            }
            apiKey = decodedToken.apiKey;
        } catch (error) {
            return {
                result: new InvalidResult<OnboardingProgressModel>(String(error))
            };
        }
    }

    return {
        result: await updateOnboardingProgressWithApiKey({
            ...progress,
            applicationId
        }, apiKey),
        apiKey
    };
};
